import cn from 'classnames';
import { motion, useReducedMotion } from 'framer-motion';

const RATIO = 34 / 30;

/**
 * A small potted plant that sways. Sits inline in a caption, so it stays on
 * screen under reduced motion; only the sway stops.
 */
export function SwayingPlant({ size = 26, className }: { size?: number; className?: string }) {
    const reduced = useReducedMotion();

    const leaves = [
        { d: 'M15 20C15 14 11 10.5 7.5 9.5 7 13.5 9.5 18.5 15 20Z', from: -4, delay: 0 },
        { d: 'M15 20c0-6 4-9.5 7.5-10.5.5 4-2 9-7.5 10.5Z', from: 4, delay: 0.5 },
        { d: 'M15 20c0-5.5 1-9.5 0-13.5-1 4 0 8 0 13.5Z', from: -2, delay: 1 }
    ];

    return (
        <svg viewBox="0 0 30 34" width={size} height={size * RATIO} className={cn('shrink-0', className)} aria-hidden="true">
            {leaves.map((leaf) =>
                reduced ? (
                    <path key={leaf.d} d={leaf.d} fill="#E9E5E0" />
                ) : (
                    <motion.path
                        key={leaf.d}
                        d={leaf.d}
                        fill="#E9E5E0"
                        style={{ transformOrigin: '15px 20px' }}
                        animate={{ rotate: [leaf.from, -leaf.from, leaf.from] }}
                        transition={{ duration: 4.2, delay: leaf.delay, repeat: Infinity, ease: 'easeInOut' }}
                    />
                )
            )}

            <path d="M7.5 21h15l-1.6 9.2a2.4 2.4 0 0 1-2.37 2H11.47a2.4 2.4 0 0 1-2.37-2z" fill="var(--accent)" />
            <rect x="6.2" y="19.4" width="17.6" height="3.1" rx="1.55" fill="var(--accent)" />
        </svg>
    );
}

export default SwayingPlant;
